module.exports = new __parcel__URL__("card_unknown.0ad4752b.png").toString();